import classNames from 'classnames'

import LoaderSVG from './LoaderSVG'
import styles from './loaderWrapper.module.scss'

interface LoaderPropTypes {
  showLoader?: boolean
  loadWrapperClassName?: string
  minHeight?: string
  loaderSize?: string
}

const Loader = (props: LoaderPropTypes) => {
  return (
    <div
      style={{ display: props.showLoader ? 'block' : 'none', minHeight: props.minHeight }}
      className={classNames(styles.loaderWrapper, props.loadWrapperClassName)}
    >
      <LoaderSVG size={props?.loaderSize} />
    </div>
  )
}

export { Loader }
